export default __webpack_public_path__ + "static/media/Physics.47d96df5.gif";